const retime = () => import(/* webpackChunkName: "tool_retime" */'@/components/tool/retime.vue')
const mintable = () => import(/*webpackChunkName: "tool_mintable"*/ '@/components/tool/mintable.vue')
const TableAdjustOdds = () => import(/* webpackChunkName: "livshow-adjust-odds" */ '@/views/liveshow/components/TableAdjustOdds.vue')
const LidaTable = () => import(/* webpackChunkName: "LidaTable" */ '@/components/common/LidaTable.vue')
const BetTimeSelect = () => import('../../views/game-lobby/components/BetTimeSelect.vue')
import BackBtn from '@/components/common/BackBtn.vue'
// const Copyright = () => import(/* webpackChunkName: "Copyright" */ '@/components/common/Copyright.vue')
import BackBottom from '@/components/common/BackBottom.vue'
import Copyright from '@/components/common/Copyright.vue'
export default function install(Vue){
    Vue.component('TableAdjustOdds', TableAdjustOdds)
    Vue.component('retime', retime)
    Vue.component('mintable', mintable)
    Vue.component('LidaTable', LidaTable)
    Vue.component('Copyright', Copyright)
    Vue.component('BackBottom', BackBottom)
    Vue.component('BackBtn', BackBtn)
}